"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var AppLayout_1 = __importDefault(require("@/Layouts/AppLayout"));
function NotFound() {
    return (react_1.default.createElement(AppLayout_1.default, { title: "Not found", renderHeader: function () { return (react_1.default.createElement("h2", { className: "header" }, "Page not found")); } },
        react_1.default.createElement("img", { src: "/images/404.svg", alt: "Page not found", style: { maxWidth: "900px", margin: "0 auto", display: "flex" } })));
}
exports.default = NotFound;
